<template>
    <v-row>
        <v-col md="12" v-if="dialog == false">
            <v-data-table
                    :headers="headers"
                    :items="items"
                    :search="search"
                    sort-by="calories"
                    class="elevation-1"
            >
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Sayfalar</v-toolbar-title>
                        <v-divider
                                class="mx-4"
                                inset
                                vertical
                        ></v-divider>
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-search"
                                label="Ara"
                                single-line
                                hide-details
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" dark class="mb-2" @click="newItem()">Ekle</v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-icon
                            small
                            class="mr-2"
                            @click="editItem(item)"
                    >
                        mdi-pen
                    </v-icon>
                    <v-icon
                            small
                            @click="deleteItem(item)"
                    >
                        mdi-delete
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">Reload</v-btn>
                </template>
            </v-data-table>
        </v-col>
        <v-col md="12" v-if="dialog" style="background: azure">
                <v-card>
                    <v-card-title>
                        <v-col md="10">
                            <span class="headline">{{ formTitle }}</span>
                        </v-col>
                        <v-col md="2">
                            <v-icon @click="dialog=false" class="float-lg-right" color="red">mdi-close</v-icon>
                        </v-col>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col sm="6" md="12">
                                    <v-text-field v-model="editedItem.page_id" label="ID" disabled="disabled"></v-text-field>
                                </v-col>
                                <v-col md="12">
                                    <v-text-field v-model="editedItem.title" @change="setPageName" label="Başlık"></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6" md="12">
                                    <p class="float-left">Sayfa URL : </p>
                                    <a class="float-left" :href="'https://sakaryadestechbilisim.com/?sayfa='+editedItem.page_name">https://sakaryadestechbilisim.com/?sayfa={{editedItem.page_name}}</a>
                                </v-col>
                                <v-col cols="12" sm="6" md="12">
                                    <v-text-field v-model="editedItem.meta_desc" label="Meta desc (Seo açıklaması)"></v-text-field>
                                </v-col>
                                <v-col sm="6" md="12">
                                    <ckeditor :editor="editor" v-model="editedItem.content" :config="editorConfig"></ckeditor>
                                </v-col>
                                <v-col cols="12" v-if="editedItem.page_id != ''">
                                    <v-row>
                                        <v-col md="4" v-for="image in images">
                                            <v-card
                                                    max-width="344"
                                                    class="mx-auto"
                                            >
                                                <v-card-actions>
                                                    <v-btn
                                                            text
                                                            color="red"
                                                            class="float-right"
                                                            @click="deleteImage(image.page_images_id)"
                                                    >
                                                        X
                                                    </v-btn>
                                                </v-card-actions>
                                                <v-img :src="'https://sakaryadestechbilisim.com/images/'+image.thumb_url" eager></v-img>
                                            </v-card>
                                        </v-col>
                                        <v-col md="12">
                                            Resim yükle
                                            <input type="file" id="file" ref="file"  multiple class="file" @input="uploadFile"/>
                                            <v-progress-circular
                                                    v-if="onUploadFly == true"
                                                    indeterminate
                                                    color="primary"
                                            >Resim yükleniyor </v-progress-circular>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Vazgeç</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Kaydet</v-btn>
                        <v-progress-circular
                                v-if="onFly == true"
                                indeterminate
                                color="primary"
                        ></v-progress-circular>
                    </v-card-actions>
                </v-card>
        </v-col>
    </v-row>
</template>

<script>
    import { loadProgressBar } from 'axios-progress-bar'
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import CKEditor from '@ckeditor/ckeditor5-vue';

    export default {
        data: () => ({
            editor: ClassicEditor,
            editorConfig: {
                // The configuration of the editor.
            },
            search:"",
            dialog: false,
            headers: [
                { text: 'ID', value: 'page_id' },
                { text: 'Başlık', value: 'title' },
                { text: 'Meta desc', value: 'meta_desc' },
                { text: 'Tarih', value: 'created_at' },
                { text: 'Düzenle/Sil', value: 'action' },
            ],
            images:[],
            onFly:false,
            onUploadFly:false,
            items: [],
            editedIndex: -1,
            file:new Blob([]),
            action:"https://sakaryadestechbilisim.com/api.php?endpoint=page",
            uploadAction:"https://sakaryadestechbilisim.com/api.php?endpoint=upload",
            editedItem: {
                page_id:'',
                title: '',
                meta_desc: '',
                content: '',
                page_name:''
            },
            defaultItem: {
                page_id:'',
                title: '',
                meta_desc: '',
                content: '',
                page_name:''
            },

        }),
        components: {
            'ckeditor': CKEditor.component
        },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Ekle' : 'Düzenle'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },

        created () {
            this.initialize()
        },

        methods: {
            onFileUploadRequest(evt) {
                console.log(evt);
            },
            onFileUploadResponse(evt) {
                console.log(evt);
            },
            async uploadFile(e){
                this.onUploadFly = true;
                let formData = new FormData();
                e.target.files.forEach(file=>{
                    formData.append("file[]",file);
                })
                let response = await this.$axios.request({
                    method:"POST",
                    url:this.uploadAction+"&page_id="+this.editedItem.page_id,
                    data:formData
                });
                this.onUploadFly = false;
                this.getImages()
            },
            initialize () {
                loadProgressBar(this.axios.config,this.axios);
                this.get();
            },
            setPageName(){
                this.editedItem.page_name = this.seoUrl(this.editedItem.title);
            },
            seoUrl(textString) {
                if(textString == undefined)
                    return "";
                textString = textString.replace(/ /g, "-");
                textString = textString.replace(/</g, "");
                textString = textString.replace(/>/g, "");
                textString = textString.replace(/"/g, "");
                textString = textString.replace(/é/g, "");
                textString = textString.replace(/!/g, "");
                textString = textString.replace(/’/, "");
                textString = textString.replace(/£/, "");
                textString = textString.replace(/^/, "");
                textString = textString.replace(/#/, "");
                textString = textString.replace(/$/, "");
                textString = textString.replace(/\+/g, "");
                textString = textString.replace(/%/g, "");
                textString = textString.replace(/½/g, "");
                textString = textString.replace(/&/g, "");
                textString = textString.replace(/\//g, "");
                textString = textString.replace(/{/g, "");
                textString = textString.replace(/\(/g, "");
                textString = textString.replace(/\[/g, "");
                textString = textString.replace(/\)/g, "");
                textString = textString.replace(/]/g, "");
                textString = textString.replace(/=/g, "");
                textString = textString.replace(/}/g, "");
                textString = textString.replace(/\?/g, "");
                textString = textString.replace(/\*/g, "");
                textString = textString.replace(/@/g, "");
                textString = textString.replace(/€/g, "");
                textString = textString.replace(/~/g, "");
                textString = textString.replace(/æ/g, "");
                textString = textString.replace(/ß/g, "");
                textString = textString.replace(/;/g, "");
                textString = textString.replace(/,/g, "");
                textString = textString.replace(/`/g, "");
                textString = textString.replace(/|/g, "");
                textString = textString.replace(/\./g, "");
                textString = textString.replace(/:/g, "");
                textString = textString.replace(/İ/g, "i");
                textString = textString.replace(/I/g, "i");
                textString = textString.replace(/ı/g, "i");
                textString = textString.replace(/ğ/g, "g");
                textString = textString.replace(/Ğ/g, "g");
                textString = textString.replace(/ü/g, "u");
                textString = textString.replace(/Ü/g, "u");
                textString = textString.replace(/ş/g, "s");
                textString = textString.replace(/Ş/g, "s");
                textString = textString.replace(/ö/g, "o");
                textString = textString.replace(/Ö/g, "o");
                textString = textString.replace(/ç/g, "c");
                textString = textString.replace(/Ç/g, "c");
                textString = textString.replace(/–/g, "-");
                textString = textString.replace(/—/g, "-");
                textString = textString.replace(/—-/g, "-");
                textString = textString.replace(/—-/g, "-");
                return textString.toLowerCase();
            } ,
            newItem(){
                this.editedItem = this.defaultItem;
                this.dialog = true;
            },
            async get(){
                this.$axios.request({
                    method:"GET",
                    url:this.action
                }).then(response=>{
                    this.items = response.data;
                })
            },
            async getImages(){
                this.onUploadFly = true;
                let response = await this.$axios.request({
                    method:"GET",
                    url:this.uploadAction+"&page_id="+this.editedItem.page_id
                });
                this.onUploadFly = false;
                this.images = response.data;
            },
            async editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialog = true
                this.getImages();
            },
            async deleteImage(page_images_id){
                let cnf = confirm('Resim silinecek onaylıyormusun ?')
                if(cnf){
                    let response = await this.$axios.request({
                        method:"DELETE",
                        url:this.uploadAction+"&page_images_id="+page_images_id
                    });
                    this.getImages();
                }
            },
            async deleteItem (item) {
                let cnf = confirm('Sayfa silinecek onaylıyormusun ?')
                if(cnf){
                    let response = await this.$axios.request({
                        method:"DELETE",
                        url:this.action+"&page_id="+item.page_id
                    });
                    this.get();
                }
            },
            close () {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                }, 300)
            },
            async delete(){

            },
            async save () {
                this.onFly = true;
                //console.log(this.editedItem);
                let response = await this.$axios.request({
                    method:"POST",
                    url:this.action,
                    data:this.editedItem
                });
                console.log(response.data);
                this.onFly = false;
                this.get();
                //this.items.push(this.editedItem);
                this.close()
            }
        },
    }
</script>
<style scoped>

</style>
